angular.module('picmonic-common').factory('Contracts', [
  '$resource',
  function ($resource) {
    return $resource(
      '/api/v3/contracts/:picmonic_contract_id',
      { picmonic_contract_id: '@picmonic_contract_id' },
      {
        update: { method: 'PUT' },
      }
    );
  },
]);
